import React from 'react';
import { styled } from "@mui/material/styles";

import ResponsiveImage from '@shared-components/atoms/ResponsiveImage';
import { AdvisoryMessageProps } from './types';

const StyledContainer = styled("div")(({ theme }) => ({
    display: "flex",
    flexDirection: "column",
    borderBlock: "1px solid var(--web-2-primary-neutral-400)",
    marginBlock: "100px 50px",
    paddingBlock: "40px 20px",
    [theme.breakpoints.up("md")]: {
        flexDirection: "row",
        alignItems: "center",
        marginTop: "50px",
        paddingBlock: "50px"
    }
}));

const StyledTitle = styled("h2")({
    fontSize: "28px",
    fontFamily: "PizzaHutFont",
    fontWeight: "initial"
});

const StyledImage = styled(ResponsiveImage)(({ theme }) => ({
    width: "100%",
    borderRadius: "8px",
    flex: 1,
    [theme.breakpoints.up("md")]: {
        width: "80%"
    }
}));

const StyledMessage = styled("div")({
    flex: 1
});

export const AdvisoryMessage = ({advisoryMessage}: AdvisoryMessageProps) => {
    const {
        title,
        description,
        image
    } = advisoryMessage;

    return (
        <StyledContainer>
            <StyledImage
                desktopImageUrl={image}
                mobileImageUrl={image}
            />
            <StyledMessage>
                <StyledTitle>{title}</StyledTitle>
                <div>{description}</div>
            </StyledMessage>
        </StyledContainer>
    )
}

export default AdvisoryMessage;